export const countries = [
  { value: '', label: 'Select a country' },
  { value: 'AGO', label: 'Angola' },
  { value: 'ESP', label: 'Spain' },
  { value: 'CMR', label: 'Cameroon' }
];

export const countriesCategories = [
  { value: '', label: 'Select a category' },
  { value: 'environment', label: 'Environment' },
  { value: 'practices', label: 'Practices' }
];

export const sectors = [
  { value: 'oil-gas', label: 'oil & gas' },
  { value: 'mining', label: 'mining' },
  { value: 'both', label: 'both sectors' }
];

export const countrySectors = [
  { value: 'oil-gas', label: 'oil & gas' },
  { value: 'mining', label: 'mining' }
];

export const allYears = [
  { value: '2017', label: '2017' },
  { value: '2021', label: '2021' }
];

export const displayBy = [
  { value: 'issue', label: 'Governance area' },
  { value: 'country', label: 'Country' }
];

export const displayByOnlyIssue = [
  { value: 'issue', label: 'Governance area' }
];

export const categories = [
  { value: '', label: 'Select a category' },
  { value: 'category0', label: 'Composite' },
  { value: 'category1', label: 'Licensing' },
  { value: 'category2', label: 'Taxation' },
  { value: 'category3', label: 'Local Impact' },
  { value: 'category4', label: 'State-owned enterprises' },
  { value: 'category5', label: 'Revenue management' },
  { value: 'category6', label: 'Revenue sharing' },
  { value: 'category7', label: 'Sovereign wealth funds' },
  { value: 'category8', label: 'Enabling environment' }
];

export const regions = [
  { value: '', label: 'Select a country grouping' },
  { value: 'ASIA P', label: 'ASIA P' },
  { value: 'EURA', label: 'EURA' },
  { value: 'LatAm', label: 'LatAm' },
  { value: 'MENA', label: 'MENA' },
  { value: 'OECD', label: 'OECD' },
  { value: 'SSA', label: 'SSA' }
];

export const indicators = [
  { value: '', label: 'Select an indicator' },
  { value: 'indicator1', label: 'Indicator 1' },
  { value: 'indicator2', label: 'Indicator 2' },
  { value: 'indicator3', label: 'Indicator 3' }
];



// WEBPACK FOOTER //
// ./app/constants/SelectsOptions.js